import React from 'react';
import './InsuranceBanner.css';

const InsuranceBanner = () => {
    return (
        <div className="insurance-banner">
            <div className="container">
                <div className="insurance-content">
                    <i className="fas fa-exclamation-triangle"></i>
                    <span className="insurance-text">
                        Stem Cell procedures ARE NOT FDA APPROVED, and are DEEMED EXPERIMENTAL. They are not covered by HEALTH INSURANCE and you are responsible for ALL COSTS. While there is high likelihood of success, there are NO GUARANTEES that this treatment will result in the desired outcome. Maintenance treatment may be needed periodically. Please consult your healthcare provider.
                    </span>
                </div>
            </div>
        </div>
    );
};

export default InsuranceBanner;